import Footer from "./Footer";
import Header from "./Header";

interface LayoutProps {
    children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
    return (
        <div className="min-w-[375px]">
            <Header />
            <div>{children}</div>
            <Footer />
        </div>
    );
}
